import React, { useState, useEffect } from 'react';
import api from './api';

const PartyMaster = () => {
    const [parties, setParties] = useState([]);
    const [form, setForm] = useState({ 
        name: '', companyName: '', mobile: '', 
        panNumber: '', gstNumber: '', 
        defaultSourceType: 'Local', // Default Selection
        defaultBillType: 'Bill',    // Default Selection
        openingBalance: 0 
    });

    const fetchParties = async () => {
        try {
            const res = await api.get('/parties');
            setParties(res.data);
        } catch (err) { console.error(err); }
    };

    useEffect(() => { fetchParties(); }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.post('/parties', form);
            alert("✅ Party Added Successfully!");
            setForm({ 
                name: '', companyName: '', mobile: '', 
                panNumber: '', gstNumber: '', 
                defaultSourceType: 'Local', defaultBillType: 'Bill',
                openingBalance: 0 
            });
            fetchParties();
        } catch (err) { alert("Error adding party: " + err.message); }
    };

    return (
        <div className="container mt-4">
            <h4 className="mb-3">Party Master (Suppliers)</h4>
            
            {/* ADD FORM */}
            <div className="card p-3 mb-4 bg-light shadow-sm">
                <form onSubmit={handleSubmit}>
                    <div className="row g-2 mb-2">
                        <div className="col-md-3">
                            <label className="small text-muted">Company Name *</label>
                            <input className="form-control form-control-sm" value={form.companyName} onChange={e => setForm({...form, companyName: e.target.value})} required />
                        </div>
                        <div className="col-md-3">
                            <label className="small text-muted">Contact Person *</label>
                            <input className="form-control form-control-sm" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
                        </div>
                        <div className="col-md-2">
                            <label className="small text-muted">Mobile</label>
                            <input className="form-control form-control-sm" value={form.mobile} onChange={e => setForm({...form, mobile: e.target.value})} />
                        </div>
                        <div className="col-md-2">
                            <label className="small text-muted">PAN (Optional)</label>
                            <input className="form-control form-control-sm" value={form.panNumber} onChange={e => setForm({...form, panNumber: e.target.value})} />
                        </div>
                        <div className="col-md-2">
                            <label className="small text-muted">GST (Optional)</label>
                            <input className="form-control form-control-sm" value={form.gstNumber} onChange={e => setForm({...form, gstNumber: e.target.value})} />
                        </div>
                    </div>

                    {/* DEFAULTS ROW */}
                    <div className="row g-2 align-items-end">
                        <div className="col-md-2">
                            <label className="small text-muted fw-bold">Default Source</label>
                            <select className="form-select form-select-sm" value={form.defaultSourceType} onChange={e => setForm({...form, defaultSourceType: e.target.value})}>
                                <option value="Local">Local</option>
                                <option value="Import">Import</option>
                            </select>
                        </div>
                        <div className="col-md-2">
                            <label className="small text-muted fw-bold">Default Bill Type</label>
                            <select className="form-select form-select-sm" value={form.defaultBillType} onChange={e => setForm({...form, defaultBillType: e.target.value})}>
                                <option value="Bill">Bill</option>
                                <option value="Cash">Cash</option>
                            </select>
                        </div>
                        <div className="col-md-2">
                            <label className="small text-muted">Op. Balance</label>
                            <input type="number" className="form-control form-control-sm" value={form.openingBalance} onChange={e => setForm({...form, openingBalance: e.target.value})} />
                        </div>
                        <div className="col-md-2 offset-md-4">
                            <button className="btn btn-primary btn-sm w-100 fw-bold">Add Party</button>
                        </div>
                    </div>
                </form>
            </div>

            {/* LIST */}
            <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                    <thead className="table-dark">
                        <tr>
                            <th>Company / Person</th>
                            <th>Contact</th>
                            <th>Tax Info</th>
                            <th>Defaults</th>
                            <th className="text-end">Total Purchased (Fy)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {parties.map(p => (
                            <tr key={p._id}>
                                <td>
                                    <div className="fw-bold">{p.companyName}</div>
                                    <small className="text-muted">{p.name}</small>
                                </td>
                                <td>{p.mobile}</td>
                                <td>
                                    <div className="small">PAN: {p.panNumber || '-'}</div>
                                    <div className="small">GST: {p.gstNumber || '-'}</div>
                                </td>
                                <td>
                                    <span className="badge bg-light text-dark border me-1">{p.defaultSourceType}</span>
                                    <span className="badge bg-light text-dark border">{p.defaultBillType}</span>
                                </td>
                                <td className="text-end fw-bold text-primary">
                                    {p.currentFyTotalPurchases?.toLocaleString('en-IN')}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
export default PartyMaster;